export default __webpack_public_path__ + "static/media/7.165fe9bf.png";